var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isServerOnline &&
      !_vm.transcoderConfigured &&
      !_vm.transmissionCompleted
        ? _c(
            "div",
            { staticClass: "row q-mb-md text-center" },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("h3", { staticClass: "text-h3 q-ma-md" }, [
                  _vm._v(_vm._s(this.title))
                ]),
                _c("p", { staticClass: "text-body1" }, [
                  _vm._v(_vm._s(this.description))
                ]),
                _c("p", { staticClass: "text-weight-medium" }, [
                  _vm._v(_vm._s(_vm.getTransmissionDate))
                ])
              ]),
              !_vm.isMicrophoneEnabled
                ? _c("div", { staticClass: "col-12" }, [
                    _c("h5", { staticClass: "text-h5" }, [
                      _vm._v(_vm._s(_vm.userCantStream))
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-btn", {
                        staticClass: "q-ma-md",
                        attrs: {
                          disabled: _vm.isServerOnline,
                          color: "primary",
                          label: _vm.$t("configure_streaming")
                        },
                        on: {
                          click: function($event) {
                            _vm.configureStreamingModal = true
                          }
                        }
                      })
                    ],
                    1
                  ),
              _c(
                "q-modal",
                {
                  attrs: {
                    "content-css": { minWidth: "60vw", minHeight: "60vh" }
                  },
                  model: {
                    value: _vm.configureStreamingModal,
                    callback: function($$v) {
                      _vm.configureStreamingModal = $$v
                    },
                    expression: "configureStreamingModal"
                  }
                },
                [
                  _c(
                    "q-modal-layout",
                    [
                      _c(
                        "q-toolbar",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("q-btn", {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            attrs: {
                              flat: "",
                              round: "",
                              dense: "",
                              icon: "close"
                            }
                          }),
                          _c("q-toolbar-title", [
                            _vm._v(_vm._s(_vm.$t("configure_streaming")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "layout-padding" },
                        [
                          _c("span", { staticClass: "caption q-mr-md" }, [
                            _vm._v(_vm._s(_vm.$t("audio_input_devices")))
                          ]),
                          _c("q-select", {
                            attrs: {
                              options: _vm.audioInputDevices,
                              label: "audio_input_devices"
                            },
                            model: {
                              value: _vm.audioInputDevice,
                              callback: function($$v) {
                                _vm.audioInputDevice = $$v
                              },
                              expression: "audioInputDevice"
                            }
                          }),
                          _vm.hasCamera
                            ? _c("span", { staticClass: "caption q-mr-md" }, [
                                _vm._v(_vm._s(_vm.$t("video_input_devices")))
                              ])
                            : _vm._e(),
                          _vm.hasCamera
                            ? _c("q-select", {
                                attrs: {
                                  options: _vm.videoInputDevices,
                                  label: "video_input_devices"
                                },
                                model: {
                                  value: _vm.videoInputDevice,
                                  callback: function($$v) {
                                    _vm.videoInputDevice = $$v
                                  },
                                  expression: "videoInputDevice"
                                }
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "caption q-mr-md" }, [
                            _vm._v(
                              _vm._s(_vm.$t("streaming_recording_quality"))
                            )
                          ]),
                          _c("q-select", {
                            attrs: {
                              options: _vm.recordingChoices,
                              label: "streaming_recording_quality"
                            },
                            model: {
                              value: _vm.recordingChoice,
                              callback: function($$v) {
                                _vm.recordingChoice = $$v
                              },
                              expression: "recordingChoice"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-toolbar",
                        { attrs: { slot: "footer" }, slot: "footer" },
                        [
                          _c("q-btn", {
                            staticClass: "q-ma-md",
                            attrs: {
                              disabled: _vm.isServerOnline,
                              color: "positive",
                              label: _vm.$t("save_settings")
                            },
                            on: {
                              click: function($event) {
                                return _vm.startConstraintsAndTranscoder()
                              }
                            }
                          }),
                          _c("q-btn", {
                            staticClass: "q-ma-md",
                            attrs: {
                              color: "negative",
                              label: _vm.$t("cancel")
                            },
                            on: {
                              click: function($event) {
                                _vm.configureStreamingModal = false
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      (_vm.transcoderConfigured && !_vm.transmissionCompleted) ||
      (_vm.isServerOnline && !_vm.transmissionCompleted)
        ? _c("div", { staticClass: "row q-mb-md" }, [
            _c(
              "div",
              { staticClass: "col-12 text-center" },
              [
                _vm.isLiveStreaming
                  ? _c("q-icon", {
                      staticClass: "q-mx-md",
                      attrs: { name: "fas fa-broadcast-tower", color: "green" }
                    })
                  : _vm._e(),
                _c("q-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isServerOnline,
                      expression: "!isServerOnline"
                    }
                  ],
                  staticClass: "q-ma-md",
                  attrs: {
                    color: "positive",
                    label: _vm.$t("create_transmission")
                  },
                  on: {
                    click: function($event) {
                      return _vm.startWowzaServer()
                    }
                  }
                }),
                _c("q-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isServerOnline &&
                        _vm.localStream &&
                        !_vm.isLiveStreaming,
                      expression:
                        "isServerOnline && localStream && !isLiveStreaming"
                    }
                  ],
                  staticClass: "q-ma-md",
                  attrs: { color: "positive", label: _vm.$t("go_live") },
                  on: {
                    click: function($event) {
                      return _vm.startStream()
                    }
                  }
                }),
                _c("q-btn-toggle", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.localStream,
                      expression: "localStream"
                    }
                  ],
                  attrs: {
                    "toggle-color": "positive",
                    options: _vm.localVideoFrameOptions
                  },
                  model: {
                    value: _vm.localVideoFrameWide,
                    callback: function($$v) {
                      _vm.localVideoFrameWide = $$v
                    },
                    expression: "localVideoFrameWide"
                  }
                }),
                _c("q-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isServerOnline &&
                        _vm.localStream &&
                        _vm.isLiveStreaming,
                      expression:
                        "isServerOnline && localStream && isLiveStreaming"
                    }
                  ],
                  staticClass: "q-ma-md",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("end_transmission")
                  },
                  on: {
                    click: function($event) {
                      _vm.endDialog = true
                    }
                  }
                }),
                _vm.transcoderConfigured &&
                !_vm.transmissionCompleted &&
                !_vm.isServerOnline
                  ? _c("div", { staticClass: "col-12 q-ma-sm" }, [
                      _c("p", { staticClass: "text-body1" }, [
                        _vm._v(_vm._s(_vm.$t("start_streaming_message")))
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            !_vm.localStream
              ? _c(
                  "div",
                  { staticClass: "col-12 q-my-md text-center" },
                  [
                    _c("q-btn", {
                      staticClass: "q-ma-md",
                      attrs: {
                        size: "22px",
                        icon: "fas fa-desktop",
                        stack: "",
                        color: "primary",
                        label: _vm.$t("start_with_display")
                      },
                      on: {
                        click: function($event) {
                          return _vm.startInitialLocalStream("display")
                        }
                      }
                    }),
                    _vm.hasCamera
                      ? _c("q-btn", {
                          staticClass: "q-ma-md",
                          attrs: {
                            size: "22px",
                            icon: "fas fa-video",
                            stack: "",
                            color: "primary",
                            disable: !_vm.hasCamera,
                            label: _vm.$t("start_with_camera")
                          },
                          on: {
                            click: function($event) {
                              return _vm.startInitialLocalStream("camera")
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.localStream || _vm.isLiveStreaming || _vm.isServerOnline
              ? _c(
                  "div",
                  { staticClass: "video-container col-auto q-mx-auto" },
                  [
                    _c(
                      "div",
                      { staticClass: "video-buttons col-12 q-ma-md" },
                      [
                        _vm.isCameraActive
                          ? _c("q-btn", {
                              staticClass: "absolute-left text-white",
                              attrs: {
                                icon: "fas fa-desktop",
                                flat: "",
                                rounded: "",
                                color: "primary",
                                label: _vm.$t("share_screen")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setVideoSource("display")
                                }
                              }
                            })
                          : _vm._e(),
                        !_vm.isCameraActive &&
                        _vm.isDisplayActive &&
                        _vm.hasCamera
                          ? _c("q-btn", {
                              staticClass: "absolute-left text-white",
                              attrs: {
                                icon: "fas fa-video",
                                flat: "",
                                rounded: "",
                                color: "primary",
                                label: _vm.$t("share_camera")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setVideoSource("camera")
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.localStream && _vm.isCameraActive
                          ? _c("q-btn", {
                              staticClass: "absolute-right text-white",
                              attrs: {
                                icon: "fas fa-cog",
                                flat: "",
                                rounded: "",
                                color: "primary",
                                label: _vm.$t("device_options")
                              },
                              on: {
                                click: function($event) {
                                  _vm.settingsModal = true
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("video", {
                      ref: "vid",
                      class: !_vm.localVideoFrameWide
                        ? "frame-narrow"
                        : "frame-wide",
                      attrs: {
                        id: "localVideo",
                        autoplay: "",
                        playsinline: "",
                        muted: ""
                      },
                      domProps: { srcObject: _vm.localStream, muted: true }
                    })
                  ]
                )
              : _vm._e()
          ])
        : _c("div", { staticClass: "col-12 q-ma-md text-center" }, [
            _vm.transmissionCompleted &&
            !_vm.transmissionDownloaded &&
            !_vm.isConvertingVideo
              ? _c(
                  "div",
                  [
                    _c("p", { staticClass: "text-body1 text-center q-ma-md" }, [
                      _vm._v(_vm._s(_vm.transmissionFinished))
                    ]),
                    _c("q-btn", {
                      staticClass: "q-ma-md",
                      attrs: {
                        color: "primary",
                        label: _vm.$t("save_webinar_video")
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveStream()
                        }
                      }
                    }),
                    _c(
                      "p",
                      { staticClass: "text-body2 text-weight-medium q-ma-md" },
                      [_vm._v(_vm._s(_vm.$t("record_warning")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.transmissionCompleted &&
            !_vm.transmissionDownloaded &&
            _vm.isConvertingVideo
              ? _c("div", [
                  _c("p", { staticClass: "text-body1 text-center q-ma-md" }, [
                    _vm._v(_vm._s(_vm.transmissionFinished))
                  ])
                ])
              : _vm._e(),
            _vm.transmissionCompleted && _vm.transmissionDownloaded
              ? _c("div", [
                  _c("p", { staticClass: "text-body1 text-center q-ma-md" }, [
                    _vm._v(_vm._s(_vm.transmissionFinished))
                  ])
                ])
              : _vm._e()
          ]),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "60vw", minHeight: "60vh" } },
          model: {
            value: _vm.settingsModal,
            callback: function($$v) {
              _vm.settingsModal = $$v
            },
            expression: "settingsModal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    attrs: { flat: "", round: "", dense: "", icon: "close" }
                  }),
                  _c("q-toolbar-title", [_vm._v(_vm._s(_vm.$t("Settings")))])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("span", { staticClass: "caption q-mr-md" }, [
                    _vm._v(_vm._s(_vm.$t("audio_input_devices")))
                  ]),
                  _c("q-select", {
                    attrs: {
                      options: _vm.audioInputDevices,
                      label: "audio_input_devices"
                    },
                    model: {
                      value: _vm.audioInputDevice,
                      callback: function($$v) {
                        _vm.audioInputDevice = $$v
                      },
                      expression: "audioInputDevice"
                    }
                  }),
                  _vm.hasCamera
                    ? _c("span", { staticClass: "caption q-mr-md" }, [
                        _vm._v(_vm._s(_vm.$t("video_input_devices")))
                      ])
                    : _vm._e(),
                  _c("q-select", {
                    attrs: {
                      options: _vm.videoInputDevices,
                      label: "video_input_devices"
                    },
                    model: {
                      value: _vm.videoInputDevice,
                      callback: function($$v) {
                        _vm.videoInputDevice = $$v
                      },
                      expression: "videoInputDevice"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-toolbar",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("q-btn", {
                    staticClass: "q-mx-xs",
                    attrs: { color: "positive", label: _vm.$t("Ok") },
                    on: { click: _vm.updateDeviceSettings }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          model: {
            value: _vm.endDialog,
            callback: function($$v) {
              _vm.endDialog = $$v
            },
            expression: "endDialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("end_transmission")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_end_transmission")))
          ]),
          _c(
            "template",
            { slot: "buttons" },
            [
              _c("q-btn", {
                attrs: { color: "secondary", label: _vm.$t("cancel") },
                on: {
                  click: function($event) {
                    _vm.endDialog = false
                  }
                }
              }),
              _c("q-btn", {
                attrs: { color: "negative", label: _vm.$t("end_transmission") },
                on: {
                  click: function($event) {
                    return _vm.stopStreaming()
                  }
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }